module.exports = __webpack_public_path__ + "img/REFRESH.cf35e02a.svg";